import { workFlowStepUpdate } from "../util/login";

export async function renderRedirect(props, url, shouldUpdateStep = true) {
  console.log("renderRedirectUrl", url);
  if (
    shouldUpdateStep &&
    localStorage.getItem("identifierName") !== "mobile_verification" &&
    localStorage.getItem("identifierName") !== "email_verification"
  ) {
    await workFlowStepUpdate(localStorage.getItem("identifier")).catch(err => console.error(err));
  }
  props.history.push(url);
}


